import React, { useEffect, useState } from "react";
import * as api from "./../../api/api";
import { Link } from "react-router-dom";
import * as c from "./../../const";
import PhotographerPlaceholder from "./../../assets/images/photo.png";

//BACKDROP STYLING
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      marginTop: theme.spacing(2),
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backgroundColor: "white",
  },
}));

export default function Profile() {
  const classes = useStyles();
  const [loader, setLoader] = useState(true);
  const [photographer, setPhotographer] = useState("");
  const [showGallery, setShowGallery] = useState(false);
  const [gallery, setGallery] = useState("");

  useEffect(() => {
    document.title = "121five.com - Photographer's Profile";
    window.scrollTo(0, 0);
    photographerApi();
  }, []);

  const photographerApi = async () => {
    try {
      let response = await api.photographer();
      if (response) {
        setPhotographer(response);
        setLoader(false);
      }
    } catch (e) {}
  };

  return (
    <>
      <div className="row mb-3">
        <div className="col-md-10 mx-auto text-center">
          <div className="headline">
            <h2>Photographer</h2>
            {/* <p>Please take a look at some of them.</p> */}
          </div>
        </div>
      </div>
      <div className="mt-0 d-flex justify-content-start flex-wrap">
        {Object.keys(photographer).map((index) => {
          const id = photographer[index].id;
          const name = photographer[index].name;
          const company_name = photographer[index].company_name;
          const email_id = photographer[index].email_id;
          const mobile_no = photographer[index].mobile_no;
          const address = photographer[index].address;
          const url = photographer[index].url;
          let src = photographer[index].gallery[0]
            ? `${c.URL}/${photographer[index].gallery[0].image}`
            : PhotographerPlaceholder;
          return (
            <div
              className="px-4 px-xs-0 py-4 rounded btn border mx-5 mb-5"
              style={{ width: "300px", overflow: "wrap" }}
            >
              <Link to={"/photographer-gallery/" + id}>
                <div className="media align-items-end profile-header">
                  <div
                    className="media-body text-white text-left"
                    style={{ overflow: "hidden" }}
                  >
                    <img
                      src={src}
                      alt="profile"
                      width="250"
                      height="200"
                      className="pb-3"
                    />

                    <h4 className="mt-0 mb-0">{name}</h4>
                    <p className="small mb-0">Studio Name: {company_name}</p>
                    <p className="small mb-0">Email Id: {email_id}</p>
                    <p className="small mb-0">Mobile No: {mobile_no}</p>
                    <p className="small mb-0">Address: {address}</p>
                    <p className="small mb-0">
                      Website:{" "}
                      <a href={url} target="blank">
                        {url}
                      </a>
                    </p>
                  </div>
                </div>
              </Link>
            </div>
          );
        })}
      </div>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress />
      </Backdrop>
    </>
  );
}
